import * as React from "react";
import { useSelector } from "react-redux";
import { StudentService } from "../../components/studentService";
import { Config } from "../../../personal-studio-components/service/Config.js";
import { QuestionsModel } from "./QuestionsModel.js";
import { QuestionsView } from "./QuestionsView.jsx";
import axios from "axios";
import ErrorBoundary from "../../components/errorBoundary/ErrorBoundary.jsx";
export { Questions, QuestionsModel, QuestionsView };
/**
 * Контроллер страницы "Консультации".
 * @returns {JSX.Element} Элемент JSX.
 * @author Алексей Васьковский <avaskovskiy@umney.ru>
 */
function Questions() {
  // Начальное состояние
  const { contractId } = useSelector((state) => state.contract);
  const { access_token } = useSelector((state) => state.token);
  const [chat_room, setChatRoom] = React.useState(0);
  const [open, setOpen] = React.useState(false);
  const [response, setResponse] = React.useState(null);
  const [student_service_url, setStudent_service_url] = React.useState("");
  const [progress, setProgress] = React.useState(0);
  const [errorFiles, setErrorFiles] = React.useState(null);
  const [errorBoundaryError, setErrorBoundaryError] = React.useState(null);
  const model = new QuestionsModel({
    env: {
      access_token,
      study_contract_id: contractId,
    },
    chat_room,
    open,
    onClick,
    onSubmit,
    onOpenChatRoom,
    onCloseChatRoom,
  });
  // Отправка запроса
  const request = model.getRequest();
  React.useEffect(() => {
    StudentService.send(request, setResponse);
  }, []);
  React.useEffect(() => {
    async function getConfig() {
      await Config.load();
      const student_service = Config.get("student_service");
      setStudent_service_url(student_service);
    }
    getConfig();
  }, []);

  // Отображение компонента
  if (!response) return <QuestionsView.LoaderView title={model.title} />;
  if (response.errors) return <QuestionsView.ErrataView errata={response} />;
  model.parseResponse(response);
  return (
    <QuestionsView
      model={model}
      progress={progress}
      errorFiles={errorFiles}
      setErrorFiles={setErrorFiles}
    />
  );
  // Обработка событий
  function onClick(event) {
    if (event.preventDefault) event.preventDefault();
    setOpen(!open);
  }

  async function onSubmit(data) {
    setProgress(0);

    try {
      await axios.post(
        student_service_url + "/student/question_tutor/add",
        { ...data, access_token, study_contract_id: contractId },
        {
          onUploadProgress: (progressEvent) => {
            setProgress(Math.round(progressEvent.progress * 100));
          },
        },
      );

      StudentService.send(request, setResponse);
      setOpen(!open);
    } catch (error) {
      if (error.response.data.error_type === "file_group") {
        setErrorFiles(error.response.data.errors);
        return;
      }
      setErrorBoundaryError(error.response.data);
      const errorEvent = new ErrorEvent("error", {
        error: error.response.data,
      });
      window.dispatchEvent(errorEvent);
      return;
    }
    if (errorBoundaryError) {
      return <ErrorBoundary error={errorBoundaryError} />;
    }
  }
  function onOpenChatRoom(row) {
    setChatRoom(row.question_tutor_id);
  }
  function onCloseChatRoom(event) {
    if (event.preventDefault) event.preventDefault();
    setChatRoom(0);
  }
}
